// Keysha Pets — scripts de la tienda nueva (vanilla, sin librerías)
(function () {
  if (window.__kpInit) return;
  window.__kpInit = true;

  var pendientes = [];

  // Muestra un elemento si ya está (aunque sea en parte) en pantalla.
  function revelarVisibles() {
    var h = window.innerHeight || document.documentElement.clientHeight;
    pendientes = pendientes.filter(function (el) {
      var r = el.getBoundingClientRect();
      if (r.top < h * 0.94 && r.bottom > 0) {
        el.classList.add('kp-visible');
        return false;
      }
      return true;
    });
  }

  var ticking = false;
  window.addEventListener('scroll', function () {
    if (ticking || !pendientes.length) return;
    ticking = true;
    requestAnimationFrame(function () { ticking = false; revelarVisibles(); });
  }, { passive: true });

  function initReveal() {
    var items = document.querySelectorAll('.kp-reveal:not([data-kp-init])');
    if (!items.length) return;
    items.forEach(function (el) { el.dataset.kpInit = '1'; pendientes.push(el); });
    if (!('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('kp-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('kp-visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0, rootMargin: '0px 0px -6% 0px' });
    items.forEach(function (el, i) {
      el.style.transitionDelay = (i % 3) * 110 + 'ms';
      io.observe(el);
    });
    revelarVisibles();
  }

  // Selector de producto: pastillas de color + tarjetas de pack.
  // Cada combinación color+pack es un <span data-kp-variant> oculto con sus datos.
  function initVariantSelect() {
    var forms = document.querySelectorAll('[data-kp-product-form]:not([data-kp-init])');
    forms.forEach(function (form) {
      form.dataset.kpInit = '1';
      var select = form.querySelector('select[name="id"]');
      var button = form.querySelector('[data-kp-add]');
      if (!select || !button) return;

      var variantes = Array.prototype.slice.call(form.parentNode.querySelectorAll('[data-kp-variant]'));
      var precio = document.querySelector('[data-kp-precio]');
      var pills = form.querySelectorAll('[data-kp-color]');
      var packs = form.querySelectorAll('[data-kp-pack]');

      function buscar(color, pack) {
        for (var i = 0; i < variantes.length; i++) {
          var v = variantes[i].dataset;
          if (v.color === color && v.pack === pack) return variantes[i];
        }
        return null;
      }

      function ahorro(v) {
        var p = Number(v.price), c = Number(v.compare);
        return c > p ? Math.round((1 - p / c) * 100) : 0;
      }

      function actualizar() {
        var colorActivo = form.querySelector('[data-kp-color][aria-pressed="true"]');
        var packActivo = form.querySelector('[data-kp-pack]:checked');
        var color = colorActivo ? colorActivo.dataset.kpColor : '';
        var pack = packActivo ? packActivo.dataset.kpPack : '';

        // Ahorro en cada tarjeta de pack, para el color elegido
        packs.forEach(function (input) {
          var el = form.querySelector('[data-kp-saving="' + input.dataset.kpPack.replace(/"/g, '\\"') + '"]');
          var v = buscar(color, input.dataset.kpPack);
          var pct = v ? ahorro(v.dataset) : 0;
          if (el) el.textContent = pct ? form.dataset.textoAhorra.replace('{pct}', pct) : '';
        });

        // Precio de cada tarjeta de pack, para el color elegido
        var nows = form.querySelectorAll('[data-kp-now]');
        Array.prototype.forEach.call(nows, function (el) {
          var v = buscar(color, el.dataset.kpNow);
          var was = el.parentNode.querySelector('[data-kp-was]');
          el.textContent = v ? v.dataset.priceText : '';
          if (was) was.textContent = (v && Number(v.dataset.compare) > Number(v.dataset.price)) ? v.dataset.compareText : '';
        });

        var elegida = buscar(color, pack) || variantes[0];
        // Muestra en la galería la foto del marco de la variante elegida
        if (elegida && elegida.dataset.img) {
          var galeria = document.querySelector('[data-kp-slider] [data-kp-track]');
          if (galeria) {
            var slides = galeria.querySelectorAll('[data-img-id]');
            for (var k = 0; k < slides.length; k++) {
              if (slides[k].dataset.imgId === elegida.dataset.img) {
                galeria.scrollTo({ left: k * galeria.clientWidth, behavior: 'smooth' });
                break;
              }
            }
          }
        }
        if (!elegida) return;
        var d = elegida.dataset;
        select.value = d.id;
        var available = d.available === 'true';
        button.disabled = !available;
        button.textContent = available ? button.dataset.labelOk : button.dataset.labelOut;

        if (precio) {
          precio.innerHTML = '';
          precio.appendChild(document.createTextNode(elegida.dataset.priceText));
          if (Number(d.compare) > Number(d.price)) {
            var s = document.createElement('s');
            s.textContent = elegida.dataset.compareText;
            precio.appendChild(s);
          }
        }
      }

      pills.forEach(function (pill) {
        pill.addEventListener('click', function () {
          pills.forEach(function (p) { p.setAttribute('aria-pressed', 'false'); });
          pill.setAttribute('aria-pressed', 'true');
          actualizar();
        });
      });
      packs.forEach(function (input) { input.addEventListener('change', actualizar); });
      actualizar();
    });
  }

  // Carrusel de fotos del producto: flechas, puntos y deslizamiento táctil
  function initSlider() {
    var sliders = document.querySelectorAll('[data-kp-slider]:not([data-kp-slider-init])');
    sliders.forEach(function (root) {
      root.dataset.kpSliderInit = '1';
      var track = root.querySelector('[data-kp-track]');
      var slides = root.querySelectorAll('.kp-slide');
      var dots = root.querySelectorAll('[data-kp-dot]');
      var prev = root.querySelector('[data-kp-prev]');
      var next = root.querySelector('[data-kp-next]');
      if (!track || !slides.length) return;

      function indice() {
        var w = track.clientWidth || 1;
        return Math.round(track.scrollLeft / w);
      }
      function ir(i) {
        var max = slides.length - 1;
        i = Math.max(0, Math.min(max, i));
        track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
      }
      function actualizar() {
        var i = indice();
        dots.forEach(function (d, k) {
          if (k === i) d.setAttribute('aria-current', 'true'); else d.removeAttribute('aria-current');
        });
        if (prev) prev.disabled = i === 0;
        if (next) next.disabled = i === slides.length - 1;
      }

      var ticking = false;
      track.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () { ticking = false; actualizar(); });
      }, { passive: true });
      if (prev) prev.addEventListener('click', function () { ir(indice() - 1); });
      if (next) next.addEventListener('click', function () { ir(indice() + 1); });
      dots.forEach(function (d) {
        d.addEventListener('click', function () { ir(Number(d.dataset.kpDot)); });
      });
      actualizar();
    });
  }

  function initAll() { initReveal(); initVariantSelect(); initSlider(); }

  document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', initAll);
})();
